import VueLazyLoad from 'vue3-lazyload'

export default VueLazyLoad